import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import ContactAndTestimonials from './components/ContactAndTestimonials';
import Footer from './components/Footer';

function App() {
  return (
    <div className="font-sans text-text bg-white min-h-screen selection:bg-primary selection:text-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <ContactAndTestimonials />
      </main>
      <Footer />
    </div>
  );
}

export default App;
